import { useQuery } from '@tanstack/react-query';

import { getEndpointGroupsById } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { EnvironmentGroup } from '../types';

import { queryKeys } from './query-keys';
import { toEnvironmentGroup } from './useGroups';

/** Get the environment group by id. **Only portainer administrators can access this endpoint.** */
export function useGroup<T = EnvironmentGroup>(
  groupId?: EnvironmentGroup['Id'],
  {
    select,
    enabled = true,
    size = false,
  }: {
    select?: (group: EnvironmentGroup | null) => T;
    enabled?: boolean;
    size?: boolean;
  } = {}
) {
  return useQuery(
    queryKeys.group(groupId, size),
    async () => {
      if (groupId === undefined) {
        return null;
      }
      const { data } = await getEndpointGroupsById({
        path: { id: groupId },
        query: { size },
      });

      return toEnvironmentGroup(data);
    },
    {
      staleTime: 50,
      select,
      enabled: enabled && groupId !== undefined,
      ...withError('Failed loading group'),
    }
  );
}
